import { render, staticRenderFns } from "./Portofolio.vue?vue&type=template&id=5028fc0e&scoped=true"
import script from "./Portofolio.vue?vue&type=script&lang=js"
export * from "./Portofolio.vue?vue&type=script&lang=js"
import style0 from "./css/portfolio.css?vue&type=style&index=0&id=5028fc0e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5028fc0e",
  null
  
)

export default component.exports